"use strict";
const _ = require('lodash');
const { getTranslation } = require('../translate');
const containersPlural = {
    Flaska: 'Flaskor',
    Burk: 'Burkar',
    Fat: 'Fat',
    Tetra: 'Tetror',
    Pappburk: 'PappersBurkar',
    'Bag-in-box/Ståpåse': 'Bag-in-box/Ståpåsar',
    Påse: 'Påsar',
    Pet: 'Pet',
    Ask: 'Askar',
    Kruka: 'Krukor',
    Kartong: 'Kartonger',
    Dunk: 'Dunkar',
    Konserv: 'Konserver',
    Kg: 'kg',
    St: 'st',
};
const getDisplayUnit = row => {
    let displayUnit = 'St';
    const container = _.get(row, 'articleInInventory.container');
    const orderUnit = _.get(row, 'articleInInventory.orderUnit');
    if (orderUnit === 'weight') {
        displayUnit = 'Kg';
    }
    else if (container && container !== 'Other') {
        displayUnit = getTranslation(`article.containers.${container}`);
    }
    return displayUnit;
};
const getPluralizedDisplayUnit = row => containersPlural[getDisplayUnit(row)];
const hasAllLocationsSet = stockTaking => _.every(stockTaking.stockTakingRows, x => x.location);
const hasAllPricesSet = stockTaking => _.every(stockTaking.stockTakingRows, x => _.isNumber(x.latestPurchasePrice));
const hasAllRowsCounted = stockTaking => _.every(stockTaking.stockTakingRows, x => _.isNumber(x.countedQuantity));
const getCountedRowPrice = row => {
    if (!row ||
        !_.isNumber(row.countedQuantity) ||
        !_.isNumber(row.latestPurchasePrice)) {
        return null;
    }
    return row.countedQuantity * row.latestPurchasePrice;
};
function getViewModel(stockTaking) {
    const result = { ...stockTaking };
    const stockTakingRows = _.get(stockTaking, 'stockTakingRows') || [];
    if (_.isEmpty(stockTakingRows))
        return result;
    const getStockTakingRows = () => {
        const viewModelRows = [...stockTaking.stockTakingRows];
        return viewModelRows.map(row => {
            const displayUnitPlural = getPluralizedDisplayUnit(row);
            return {
                ...row,
                displayUnit: displayUnitPlural,
            };
        });
    };
    return {
        ...result,
        stockTakingRows: getStockTakingRows(),
    };
}
const getLocations = entity => _.chain(entity.stockTakingRows)
    .filter(x => x.location)
    .map(x => x.location)
    .sort()
    .uniq()
    .map(x => ({ value: x, label: x.replace(/\|/g, '>') }))
    .value();
module.exports = {
    getViewModel,
    getLocations,
    getPluralizedDisplayUnit,
    hasAllLocationsSet,
    hasAllPricesSet,
    hasAllRowsCounted,
    getCountedRowPrice,
};
